import React from 'react'
import {Link} from 'react-router-dom'
import styled from 'styled-components'
import {injectIntl} from 'react-intl'
import Fields from './Fields'
import logo from './logo.svg'
import image_1 from 'images/login-image-desk-1.png'
import image_2 from 'images/login-image-desk-2.png'
import image_1_retina from 'images/login-image-desk-1@2x.png'
import image_2_retina from 'images/login-image-desk-2@2x.png'
import pattern from './pattern.svg'

const Logo = styled.div`
    align-self: flex-start;
    position: absolute;
    margin: 10px;
    background-image: url(${logo});
    background-repeat: no-repeat;
    display: inline-block;
    height: 32px;
    width: 152px;
`

const Caption = styled(Link)`
    align-self: center;
    color: inherit;
`

const Form = styled.form`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 400px;
    position: absolute;
    transition: all .5s cubic-bezier(.55, 0, .1, 1);
    top: calc(50% - 200px);
`

const Main = styled.div`
    display: flex;
    flex-direction: column;
    width: 400px;
    margin: 0 auto;
    justify-content: center;
`

const Images = styled.div`
    background-image: url(${pattern});
    background-color: ${props => props.type === 'login' ? '#415dd4' : '#ffba00'};
    background-position-x: ${props => props.type === 'login' ? '' : '-100px'};
    background-blend-mode: color-burn;
    background-size: cover;
    max-width: 550px;
    min-width: 300px;
    width: 39%;
    display: flex;
    align-items: flex-end;
    position: relative;
    overflow: hidden;
    transition: background-position .5s cubic-bezier(.55, 0, .1, 1), background-color .5s cubic-bezier(.55, 0, .1, 1);

    img {
        position: absolute;
        min-width: 350px;
        width: 100%;
        transition: transform .5s cubic-bezier(.55,0,.1,1);
    }
`

const Container = styled.div`
    display: flex;
    height: 100vh;
`

const Title = styled.div`
    font-weight: 700;
    font-size: 28px;
    margin: 20px 0;
`

const Desktop = ({type, password, repeat, instance, instances, handleChange, handleRegistration, handleClickPassword, intl, handleLogin}) => (
	<Container>
		<Images type={type}>
			<Logo />
			<img src={image_1} srcSet={`${image_1_retina} 2x`} alt="" style={type === 'login' ? {} : {transform: 'translate3d(-100%, 0, -1px)'}} />
			<img src={image_2} srcSet={`${image_2_retina} 2x`} alt="" style={type === 'registration' ? {transform: 'translate3d(10px, 0, 1px)'} : {transform: 'translate3d(100%, 0, 1px)'}}/>
		</Images>
		<Main>
			<Form method="post" onSubmit={handleLogin} style={type === 'login' ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'}}>
				<Title>{intl.formatMessage({id: "login.title"})}</Title>
				<Fields
					password={password}
					handleClickPassword={handleClickPassword}
					instances={instances}
					instance={instance}
					handleChange={handleChange}
					handleLogin={handleLogin}
					type={type}
				/>
				<Caption to={'/registration'}>{intl.formatMessage({id: "login.caption_login"})}</Caption>
			</Form>
			<Form method="post" onSubmit={handleRegistration} style={type === 'registration' ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility: 'hidden'}}>
				<Title>{intl.formatMessage({id: "login.registration"})}</Title>
				<Fields
					password={password}
					handleClickPassword={handleClickPassword}
					instances={instances}
					instance={instance}
					handleChange={handleChange}
					handleRegistration={handleRegistration}
					type={type}
					repeat={repeat}
				/>
				<Caption to={'/login'}>{intl.formatMessage({id: "login.caption_registration"})}</Caption>
			</Form>
		</Main>
	</Container>
)

export default injectIntl(Desktop)
